import { categories } from '@/mocks/categories';

const featuredIds = [1, 2, 3];

const featuredImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20designer%20white%20leather%20sneakers%20on%20warm%20sand%20surface%2C%20soft%20natural%20daylight%2C%20elevated%20editorial%20aesthetic%2C%20subtle%20warm%20shadows%2C%20luxury%20minimal%20composition&width=800&height=600&seq=cat-v2-shoes&orientation=landscape",
  2: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20folded%20cashmere%20hoodie%20in%20warm%20taupe%20on%20cream%20background%2C%20soft%20natural%20daylight%2C%20texture%20visible%2C%20clean%20editorial%20aesthetic%2C%20elevated%20fashion%20flatlay&width=800&height=600&seq=cat-v2-hoodies&orientation=landscape",
  3: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20premium%20cotton%20t-shirt%20in%20warm%20cream%20folded%20neatly%20on%20light%20wood%20surface%2C%20soft%20natural%20lighting%2C%20gentle%20shadow%2C%20elevated%20editorial%20style&width=800&height=600&seq=cat-v2-tshirt&orientation=landscape"
};

const buttonImages: Record<number, string> = {
  4: "https://readdy.ai/api/search-image?query=Folded%20designer%20jacket%20minimal%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-jackets&orientation=squarish",
  5: "https://readdy.ai/api/search-image?query=Folded%20tailored%20pants%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-pants&orientation=squarish",
  6: "https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-headwear&orientation=squarish",
  7: "https://readdy.ai/api/search-image?query=Matching%20fashion%20set%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-sets&orientation=squarish",
  8: "https://readdy.ai/api/search-image?query=Folded%20cotton%20underwear%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-underwear&orientation=squarish",
  9: "https://readdy.ai/api/search-image?query=Sports%20jersey%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-jersey&orientation=squarish",
  10: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20watch%20bracelet%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-accessories&orientation=squarish",
  11: "https://readdy.ai/api/search-image?query=Designer%20handbag%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-bags&orientation=squarish",
  12: "https://readdy.ai/api/search-image?query=Leather%20belt%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-belts&orientation=squarish",
  13: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-perfumes&orientation=squarish",
  14: "https://readdy.ai/api/search-image?query=Mixed%20fashion%20items%20minimalist%20warm%20cream%20background%20clean%20product%20photography%20soft%20lighting&width=120&height=120&seq=btn-other&orientation=squarish"
};

export default function CategoryGrid() {
  const featured = categories.filter((c) => featuredIds.includes(c.id));

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-3">Categorie</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.12]">
            Esplora le
            <br />
            <span className="font-normal italic">categorie top</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl bg-background-100/60 overflow-hidden transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={featuredImages[cat.id]}
                  alt={cat.nameIt}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="px-5 py-5">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-300">
                  {cat.nameIt}
                </h3>
                <p className="text-sm text-foreground-500 mt-1">
                  {cat.name}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {categories.filter((c) => !featuredIds.includes(c.id)).map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-background-100/80 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-background-100 overflow-hidden flex-shrink-0 group-hover:ring-2 group-hover:ring-primary-300 transition-all">
                <img
                  src={buttonImages[cat.id]}
                  alt={cat.nameIt}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-foreground-800 group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                  {cat.nameIt}
                </span>
                <span className="block text-xs text-foreground-400">{cat.name}</span>
              </div>
              <i className="ri-arrow-right-up-line text-sm text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}